import classNames from 'classnames';
export default function FlagUnitedKingdomIcon({ size = 24, className }) {
    return (<svg width={(size * 8) / 5} height={size} viewBox="4 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames(className)}>
      {/* Blue field */}
      <rect width="40" height="20" fill="#012169"/>
      {/* White diagonals (saltire) */}
      <path d="M0 0L40 20M40 0L0 20" stroke="#ffffff" strokeWidth="4"/>
      {/* Red counterchanged diagonals (St Patrick), clipped into quadrants */}
      <clipPath id="flagUnitedKingdomClip">
        <path d="M20 10L40 10L40 20zM20 10L40 10L40 0zM20 10L0 10L0 0zM20 10L0 10L0 20z"/>
      </clipPath>
      <path d="M0 0L40 20M40 0L0 20" clipPath="url(#flagUnitedKingdomClip)" stroke="#c8102e" strokeWidth="2"/>
      {/* White St George cross */}
      <path d="M20 0V20M0 10H40" stroke="#ffffff" strokeWidth="6"/>
      {/* Red St George cross */}
      <path d="M20 0V20M0 10H40" stroke="#c8102e" strokeWidth="3.5"/>
    </svg>);
}
